import AvailabilityProvider from './AvailabilityProvider'
import BookingType from '../models/BookingType'
import DateService from '../services/DateService'
import Offer from '../models/Offer'

export default class BookingTypesProvider extends AvailabilityProvider {

    get offers (): Offer[] {
        return this.booking.venue!.offers
    }

    requestBookingTypes (): Promise<BookingType[]> {
        const url = this._buildUrl(this.booking.venue!)
        let params: { [index in string]: any } = {
            fields: 'type',
            getOffers: true
        }

        if (this.booking.pax) params.num_people = this.booking.pax
        if (this.booking.date) params.date = DateService.formatDateForAPI(this.booking.date)

        const requestUrl = url + this.objToParams(params)

        return this.get(requestUrl)
            .then((response) => {
                const payload = response.data.payload
                const typeValues = payload.validation.type.suggestedValues
                let types: any[] = []
                let type: BookingType

                typeValues.forEach((value: any) => {
                    type = new BookingType(value)
                    type.fillOffers(this.offers)

                    types.push(type)
                })

                return this.sortByAvailability(types)
            })
    }

    sortByAvailability (types: BookingType[]): BookingType[] {
        let available: BookingType[] = []
        let unavailable: BookingType[] = []

        types.forEach((type) => {
            if (type.isValid) {
                available.push(type)
            } else {
                unavailable.push(type)
            }
        })

        return [...available, ...unavailable]
    }
}



// WEBPACK FOOTER //
// ./src/services/BookingTypesProvider.ts